import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ResetPassword() {
  const { token } = useParams();
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("La password deve avere almeno 6 caratteri");
    if (password !== confirm) return toast.error("Le due password non coincidono");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      if (data.access_token) localStorage.setItem("access_token", data.access_token);
      setUser(data);
      toast.success("Password aggiornata");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Link non valido o scaduto");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 grain">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex justify-center mb-8" data-testid="reset-brand-link">
          <img src="/brand/logo-black.png" alt="ourweddly" className="h-12 w-auto" />
        </Link>
        <p className="eyebrow mb-3 text-center">Recupero password</p>
        <h1 className="font-wed text-4xl mb-8 text-center">Scegli una nuova password</h1>
        <div className="bg-white border rounded-3xl p-8 space-y-5" style={{ borderColor: "#e3ddd2" }}>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="label-wed">Nuova password</label>
              <input className="input-wed" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required data-testid="reset-password-input" />
            </div>
            <div>
              <label className="label-wed">Conferma password</label>
              <input className="input-wed" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="••••••••" required data-testid="reset-password-confirm-input" />
            </div>
            <button type="submit" className="btn-wed w-full" disabled={loading} data-testid="reset-submit-button">
              {loading ? "Salvataggio…" : "Imposta nuova password"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
